export const parseISODate = (dateString) => {
  if (!dateString) return null;
  const [datePart, timePart] = dateString.split('T');
  const [year, month, day] = datePart.split('-');
  const [hours, minutes] = timePart.split(':');
  
  return {
    year: parseInt(year),
    month: parseInt(month),
    day: parseInt(day),
    hours: parseInt(hours),
    minutes: parseInt(minutes)
  };
};

export const formatTime = (dateString) => {
  const date = parseISODate(dateString);
  if (!date) return '';
  
  const hour = date.hours;
  const ampm = hour >= 12 ? 'pm' : 'am';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${String(date.minutes).padStart(2, '0')} ${ampm}`;
};

export const isSameDay = (date1, date2) => {
  if (!date1 || !date2) return false;
  const d1 = parseISODate(date1);
  const d2 = parseISODate(date2);
  if (!d1 || !d2) return false;
  
  return d1.year === d2.year && 
         d1.month === d2.month && 
         d1.day === d2.day;
};

export const createISOString = (year, month, day) => {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T00:00:00`;
};

export const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const formatDateDisplay = (dateString) => {
  const date = parseISODate(dateString);
  if (!date) return '';
  return `${monthNames[date.month - 1]} ${date.day}, ${date.year}`;
}; 